export enum Currency {
  USD='USD',
  EUR='EUR',
  C4E="C4E",
  USDT="USDT",
  USDC="USDC",
  STABLE="USDT/USDC",
  PLN="PLN"
}
